import { render } from "./WheelchairIntro.vue?vue&type=template&id=464a2384&scoped=true"
import script from "./WheelchairIntro.vue?vue&type=script&lang=js"
export * from "./WheelchairIntro.vue?vue&type=script&lang=js"

import "./WheelchairIntro.vue?vue&type=style&index=0&id=464a2384&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464a2384"]])

export default __exports__